module.exports = __webpack_public_path__ + "static/img/3.e4a848e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/3.png
// module id = 5wBs
// module chunks = 0